import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'igus',
} as IModuleProps;
